<template>
    <div>
        <search @find="getSearch"></search>
        <div class="page-wrapper">
            <table-list 
                title="日志列表"
                :columns="columns"
                :data="data"
                :total="total"
                :current="current"
                :loading="loading" 
                @change-page="changePage">
            </table-list>
        </div>
    </div>
</template>
 
<script type="text/ecmascript-6">
import Search from './components/Search';
import TableList from 'components/TableList';
import { getLogsList } from 'api/ladder.js';
export default {
    name:'ladderlogs',
    components: {
        Search,
        TableList
    },
    created () {
        this.initList();
    },
    data () {
        return {
            data:[],
            total:0,
            current : 1,
            loading:false,
            columns:[
                {
                    type:'index',
                    width:60,
                    align:'center'
                },
                {
                    title:'项目名称',
                    align:'center',
                    key:'projectName',
                    width:200,
                },
                {
                    title:'楼栋',
                    align:'center',
                    key:'buildingName',
                     width:100,
                },
                {
                    title:'设备类型',
                    align:'center',
                    key:'deviceTypeName',
                    width:200,
                },
                {
                    title:'设备名称',
                    align:'center',
                    key:'deviceName',
                    width:200,
                },
                {
                    title:'设备ID',
                    align:'center',
                    key:'deviceId',
                    width:200,
                },
                {
                    title:'设备SN码',
                    align:'center',
                    key:'deviceSn',
                    width:200,
                },
                {
                    title:'租客姓名',
                    align:'center',
                    key:'userName',
                    width:200,
                },
                {
                    title:'租客联系方式',
                    align:'center',
                    key:'userPhone',
                    width:200,
                },
                {
                    title:'令令ID',
                    align:'center',
                    key:'llingId',
                    width:200,
                },
                {
                    title:'开门方式',
                    align:'center',
                    key:'noticeName',
                    width:200,
                },
                {
                    title:'开门时间',
                    align:'center',
                    key:'openTime',
                    width:200,
                },
                {
                    title:'二维码Key',
                    align:'center',
                    key:'qrcodeKey',
                    width:300,
                },
                {
                    title:'卡UID',
                    align:'center',
                    key:'cardUid',
                    width:200,
                },
            ],
            params:{
                projectFid:'',
                buildingFid:'',
                deviceName:'',
                userName:'',
                userPhone:'',
                deviceType:'',
                noticeName:'',
                openTimeStart:'',
                openTimeEnd:'',
                limit:10,
                page:1
            },
        }
    },
    methods: {
        changePage(n) {
            this.params.page = n;
            this.current = n;
			this.initList();
        },
        getSearch(params){
            this.current = 1;
            this.params = JSON.parse(JSON.stringify(params));
            this.initList();
        },
        initList() {
            getLogsList(this.params).then(res => {
                console.log(res);
                this.data = res.data.rows;
                this.total = res.data.total;
            })
        },

    }
}
</script>